import { useMutation } from '@gogame/query';
import {
  useLinkBasenameWithRoot,
  useScreenModalV2,
  useScreenState,
} from '@gogame/screens';

import ConfirmDialog from 'scenes/IO/components/ConfirmDialog';
import { GetIOEntityName } from 'scenes/IO/helpers';
import { ioDetailsLink } from 'scenes/IO/navigation';
import { approveIo } from 'scenes/IO/sources/io';

import { approve } from '../queryKeyFactory';

export const useApproveIo = (io) => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const screenState = useScreenState();
  const ioDetailsBasename = useLinkBasenameWithRoot(ioDetailsLink);
  const entityName = GetIOEntityName(io);

  const approveMutation = useMutation(approve(), approveIo, {
    successMessage: () => `${entityName} approved`,
    onSuccess: (response) => {
      if (response.redirectUrl) {
        window.location.replace(response.redirectUrl);
        return response;
      }
    },
  });
  const handleApprove = async () => {
    //TODO: when we update React Router to v4 needed to use "useHistory" method instead "v3" string.
    const { id } = io;

    const currentIoUrl = `${window.location.origin}${ioDetailsLink.stringify(
      {
        ...screenState,
        id: id,
        ioStatusBeforeDocuSigning: io.status.id,
      },
      {
        basename: ioDetailsBasename,
      }
    )}`;
    const { comment } = await showModal({
      confirmActionLabel: 'Approve',
      title: `Approve ${entityName}?`,
      io: io,
      withTextField: true,
      textFieldRequired: false,
    });

    await approveMutation.mutateAsync({ id, comment, returnUrl: currentIoUrl });
  };

  return [handleApprove, approveMutation];
};
